import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useAuthStore } from "@/store/auth";
import { connectSocket, disconnectSocket } from "@/lib/socket";

export function SocketBootstrap() {
  const status = useAuthStore((s) => s.status);
  const queryClient = useQueryClient();

  useEffect(() => {
    if (status !== "authenticated") {
      disconnectSocket();
      return;
    }

    const socket = connectSocket();
    const refetchReservations = () => {
      queryClient.invalidateQueries({ queryKey: ["reservations"] });
      queryClient.invalidateQueries({ queryKey: ["matches", "live"] });
    };

    // "connect" cubre tanto la conexion inicial como cada reconexion: si el
    // cliente estuvo desconectado y se perdio eventos, esto lo resincroniza
    // pidiendo la lista real en vez de intentar reproducir cada evento perdido.
    socket.on("connect", refetchReservations);
    socket.on("reservation:created", refetchReservations);
    socket.on("reservation:updated", refetchReservations);
    socket.on("reservation:cancelled", refetchReservations);

    return () => {
      socket.off("connect", refetchReservations);
      socket.off("reservation:created", refetchReservations);
      socket.off("reservation:updated", refetchReservations);
      socket.off("reservation:cancelled", refetchReservations);
    };
  }, [status, queryClient]);

  return null;
}
